import { Feature } from 'geojson'
import { MapboxMap } from 'react-map-gl'
import { bbox } from 'turf'

const validateCoordinates = (minLng: number, minLat: number, maxLng: number, maxLat: number): boolean => {
  // Validate coordinates
  if (!isFinite(minLng) || !isFinite(minLat) || !isFinite(maxLng) || !isFinite(maxLat)) {
    console.warn('[mapUtils] Invalid coordinates detected:', { minLng, minLat, maxLng, maxLat })
    return false
  }
  
  // Check latitude bounds
  if (minLat < -90 || minLat > 90 || maxLat < -90 || maxLat > 90) {
    console.warn('[mapUtils] Latitude out of bounds:', { minLat, maxLat })
    return false
  }
  
  // Check longitude bounds
  if (minLng < -180 || minLng > 180 || maxLng < -180 || maxLng > 180) {
    console.warn('[mapUtils] Longitude out of bounds:', { minLng, maxLng })
    return false
  }
  
  return true
}

export const zoomMapTo = (map: MapboxMap | undefined, features: Array<Feature>) => {
  try {
    if (!map || !features.length) {
      return
    }
    
    const [minLng, minLat, maxLng, maxLat] = bbox({
      type: 'FeatureCollection',
      features: features,
    })
    
    if (!validateCoordinates(minLng, minLat, maxLng, maxLat)) {
      return
    }
    
    map.fitBounds(
      [
        [minLng, minLat],
        [maxLng, maxLat],
      ],
      { padding: 40, duration: 1000, maxZoom: 20 }
    )
  } catch (error) {
    console.error('[mapUtils] Error in zoomMapTo:', error)
  }
}

export const centerMapTo = (map: MapboxMap | undefined, features: Array<Feature>) => {
  try {
    if (!map || !features.length) {
      return
    }
    
    const [minLng, minLat, maxLng, maxLat] = bbox({
      type: 'FeatureCollection',
      features: features,
    })
    
    if (!validateCoordinates(minLng, minLat, maxLng, maxLat)) {
      return
    }
    
    if (!map.isRotating() && !map.isEasing() && !map.isZooming()) {
      const centerLng = (maxLng + minLng) / 2
      const centerLat = (maxLat + minLat) / 2
      
      map.flyTo({ 
        animate: true, 
        duration: 100, 
        center: [centerLng, centerLat] 
      })
    }
  } catch (error) {
    console.error('[mapUtils] Error in centerMapTo:', error)
  }
}